/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";
import PropTypes from "prop-types";

import { gatherClasses, isFunction } from "../../lib/utils";
import Label from "../label/label";
import "./toggleButton.scss";

class ToggleButton extends React.Component {
  onClick = event => {
    const { disabled, onClick, isActive, name } = this.props;
    if (!disabled && isFunction(onClick)) {
      onClick.call(null, name, !isActive, event);
    }
  };

  render() {
    const { disabled, isActive, label, isInvalid, dataTestId } = this.props;
    const sliderClass = `oui-toggle-slider ${isActive ? "oui-on" : "oui-off"}`;
    return (
      <button
        type="button"
        data-testid={dataTestId}
        className={gatherClasses(this.props, "oui-toggle-button")}
        onKeyDown={e => {
          if (e.keyCode === 32) {
            this.onClick(e);
          }
        }}
      >
        <div
          className={gatherClasses(
            null,
            "oui-main-switch",
            disabled && "oui-disabled"
          )}
          onClick={this.onClick}
          onKeyDown={null}
          tabIndex="-1"
          role="button"
          aria-label={isActive ? "toggle button on" : "toggle button off"}
        >
          <span className={sliderClass}> </span>
        </div>
        {label && (
          <Label
            className={gatherClasses(
              null,
              "oui-switch-label",
              isInvalid && "oui-is-invalid"
            )}
            text={label}
          />
        )}
      </button>
    );
  }
}

ToggleButton.defaultProps = {
  name: "",
  isActive: false,
  dataTestId: "orion-toggle-button"
};

ToggleButton.propTypes = {
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  name: PropTypes.string,
  dataTestId: PropTypes.string
};

ToggleButton.displayName = "OrionToggleButton";

export default ToggleButton;
